module.exports = __webpack_public_path__ + "static/img/a084.5485088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a084.jpg
// module id = coAP
// module chunks = 0